import "./ChartConfig";
import { useEffect, useState } from "react";
import DashboardCalendar from "./DashboardCalendar";
import CountCards from "./CountCards";
import StaffsSalesCounts from "./StaffsSalesCounts";
import TaskDetails from "./TaskDetails";
import CustomerTypesCount from "./CustomerTypesCount";
import BookingCountBar from "./BookingCountBar";
import CarBarChart from "./CarBarChart";
import Handler from "../../Helpers/Components/Handler";

const Index = () => {
    const [filter, setFilter] = useState({ startDate: new Date(), endDate: new Date(), labelType: "week" });
    const defaultData = {
        bookingData: {
            bookingCounts: [],
            daysCounts: []
        },
        dashboardCounts: {
            customers: {
                total: 0,
                verified: 0,
                partiallyVerified: 0,
                unVerified: 0,
            },

            bookings: {
                total: 0,
                booked: 0,
                ongoing: 0,
                completed: 0,
                pending: 0,
                cancelled: 0,
            },

            leads: {
                total: 0,
                converted: 0,
                following: 0,
                rejected: 0,
                closed: 0,
            },

            revenue: {
                total: 0,
                collected: 0,
                pending: 0,
            },
        },
        taskCounts: {
            delivery: {
                total: 0,
                completed: 0,
                pending: 0
            },
            pickup: {
                total: 0,
                completed: 0,
                pending: 0
            }
        },
        staffSaleCounts: [
            { 'ananthan s': { booked: 0, delivery: 0, pickup: 0 } },
            { 'durga k': { booked: 0, delivery: 0, pickup: 0 } },
            { 'arunkumar c': { booked: 0, delivery: 0, pickup: 0 } },
            // { karthik: { booked: 0, delivery: 0, pickup: 0 } },
            // { 'sivananthi k': { booked: 0, delivery: 0, pickup: 0 } },
            { 'parthiban m': { booked: 0, delivery: 0, pickup: 0 } },
            // { suresh: { booked: 0, delivery: 0, pickup: 0 } },
            { 'ajithkumar s': { booked: 0, delivery: 0, pickup: 0 } },
            { 'siva np': { booked: 1, delivery: 1, pickup: 0 } },
            { 'sakthi velan': { booked: 0, delivery: 0, pickup: 0 } },
            { 'sivaraman v': { booked: 0, delivery: 0, pickup: 0 } },
            { jeyaprakash: { booked: 0, delivery: 0, pickup: 0 } },
            // { aravind: { booked: 0, delivery: 0, pickup: 0 } },
            { 'karthik k': { booked: 0, delivery: 0, pickup: 0 } },
            // { 'REENA(A)': { booked: 0, delivery: 0, pickup: 0 } },
            // { 'SAKTHIVELAN(A)': { booked: 0, delivery: 0, pickup: 0 } },
            { 'JEYAPRAKASH(A)': { booked: 0, delivery: 0, pickup: 0 } },
            // { 'MUTHUKUMAR(A)': { booked: 0, delivery: 0, pickup: 0 } }
        ],
        carBookingCounts: [{
            carName: "Car",
            count: 0
        }],
        bookingCustType: []
    }
    const [data, setData] = useState(defaultData)
    const fetchData = async () => {
        const response = await Handler({ method: "post", url: "/admin/dashboard/data", data: { from: filter?.startDate, to: filter?.endDate, chosen: filter?.labelType } })
        if (response?.success) {
            setData(response?.data);
        } else {
            setData(defaultData)
        }
    }
    useEffect(() => {
        fetchData()
    }, [filter])
    return (
        <div className="dashboard-header-wrapper">
            <DashboardCalendar filter={filter} setFilter={setFilter} />
            <div className="row mt-1 g-3">
                <div className="col-lg-9 col-12">
                    <BookingCountBar filter={filter} data={data?.bookingData} />
                </div>
                <div className="col-lg-3 col-12">
                    <div className="d-flex flex-column gap-3 h-100">
                        <CountCards data={data?.dashboardCounts} />
                    </div>
                </div>
            </div>

            <div className="row mt-1 g-3">
                <div className="col-lg-3 col-12">
                    <TaskDetails data={data?.taskCounts} />
                </div>

                <div className="col-lg-9 col-12">
                    <StaffsSalesCounts data={data?.staffSaleCounts} />
                </div>
            </div>

            <div className="row mt-1 g-3">
                <div className="col-lg-9 col-12">
                    <CarBarChart data={data?.carBookingCounts} />
                </div>

                <div className="col-lg-3 col-12">
                    <CustomerTypesCount data={data?.bookingCustType} />
                </div>
            </div>
        </div>
    );
};

export default Index;